// ./context/course/courseInitialState.js

export default {
    courseData: [],
    categories: [],
    currentCourse: null,
    courseLessons: [],
    courseLabs: [],
    courseQuizzes: [],
    courseExams: [],
    courseCapstones: [],
    courseModules: [],
    enrolledStudents: [],
    searchResults: [],
    publishedCourses: [],
    courseAnalytics: null,
    courseDomains: {},
    isLoading: false,
    error: null
}